function mebibyteToByte(mebibyte) {
  return mebibyte * 1024 * 1024;
}
function byteToKibibyte(byte) {
  return byte / 1024;
}
function byteToMebibyte(byte) {
  return byte / 1024 / 1024;
}
function byteToMegabyte(byte) {
  return byte / 1e3 / 1e3;
}
function byteToKilobyte(byte) {
  return byte / 1e3;
}

export { byteToKibibyte, byteToKilobyte, byteToMebibyte, byteToMegabyte, mebibyteToByte };
//# sourceMappingURL=sizeConverters.mjs.map
